export default function HeroSection() {
  return (
    <section id="inicio" className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-blue-50 via-white to-purple-50 dark:from-gray-900 dark:via-gray-900 dark:to-gray-800">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5 dark:opacity-10">
        <div className="absolute top-10 left-10 w-20 h-20 border-2 border-blue-500 rounded-lg rotate-12 animate-pulse"></div>
        <div className="absolute top-32 right-20 w-16 h-16 border-2 border-purple-500 rounded-full rotate-45 animate-bounce"></div>
        <div className="absolute bottom-20 left-1/4 w-12 h-12 border-2 border-cyan-500 rounded-lg rotate-45 animate-pulse"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Contenido Principal */}
          <div className="text-center lg:text-left">
            <div className="flex flex-wrap gap-3 justify-center lg:justify-start mb-6">
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200">
                <i className="ri-check-line mr-1"></i>
                Prueba gratuita 30 días
              </span>
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200">
                <i className="ri-refresh-line mr-1"></i>
                Actualizaciones constantes
              </span>
            </div>

            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 dark:text-white mb-6 leading-tight">
              Gestiona tus archivos
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
                como nunca antes
              </span>
            </h1>

            <p className="text-lg md:text-xl text-gray-600 dark:text-gray-300 mb-8 max-w-2xl">
              AbiSoft Explorer revoluciona tu experiencia de administración de archivos con velocidad, elegancia y potencia profesional. 
              Para todo público, con actualizaciones constantes.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-8">
              <button className="px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white text-lg font-semibold rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all transform hover:scale-105 shadow-lg flex items-center justify-center whitespace-nowrap cursor-pointer">
                <i className="ri-download-line mr-2"></i>
                Descargar Ahora
              </button>
              <button className="px-8 py-4 border-2 border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 text-lg font-semibold rounded-xl hover:bg-gray-50 dark:hover:bg-gray-800 transition-all flex items-center justify-center whitespace-nowrap cursor-pointer">
                <i className="ri-play-circle-line mr-2"></i>
                Ver Demo en Vivo
              </button>
            </div>

            <p className="text-sm text-gray-500 dark:text-gray-400">
              Disponible para Windows, macOS y App Store • Solo $30 USD/año
            </p>
          </div>

          {/* Imagen del Producto */}
          <div className="relative">
            <div className="relative z-10 transform hover:scale-105 transition-transform duration-300">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20file%20manager%20application%20interface%20screenshot%20showing%20elegant%20dark%20theme%20with%20folder%20navigation%2C%20file%20preview%20panels%2C%20and%20clean%20organized%20layout%20on%20computer%20screen%2C%20professional%20software%20design%20with%20blue%20and%20purple%20accent%20colors&width=600&height=400&seq=hero-main&orientation=landscape"
                alt="AbiSoft Explorer Interface"
                className="w-full h-auto rounded-2xl shadow-2xl border border-gray-200 dark:border-gray-700"
              />
            </div>
            
            {/* Floating UI Elements */}
            <div className="absolute -top-4 -right-4 bg-white dark:bg-gray-800 rounded-lg shadow-lg p-3 border border-gray-200 dark:border-gray-700 animate-bounce">
              <div className="flex items-center space-x-2">
                <i className="ri-search-line text-blue-500"></i>
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300">Búsqueda instantánea</span>
              </div>
            </div>

            <div className="absolute -bottom-4 -left-4 bg-white dark:bg-gray-800 rounded-lg shadow-lg p-3 border border-gray-200 dark:border-gray-700 animate-pulse">
              <div className="flex items-center space-x-2">
                <i className="ri-eye-line text-purple-500"></i>
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300">Vista previa</span>
              </div>
            </div>

            {/* Background Glow */}
            <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-purple-400 opacity-20 blur-3xl -z-10"></div>
          </div>
        </div>

        {/* Estadísticas */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16 pt-16 border-t border-gray-200 dark:border-gray-700">
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-2">50K+</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Descargas</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-2">4.9★</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Calificación</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-2">200+</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Formatos</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-2">24/7</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Soporte</div>
          </div>
        </div>
      </div>
    </section>
  );
}